import type { RouteObject } from 'react-router-dom'
import { profilePathPrefixes } from './route-paths'

export const reviewHistoryRoutes: RouteObject[] = [
  ...[
    profilePathPrefixes.reviewHistory,
    profilePathPrefixes.firstRound,
    profilePathPrefixes.secondRound,
    profilePathPrefixes.thirdRound,
  ].map((path) => ({
    path: path.slice(1),
    lazy: () => import('../../features/learning/ui/ReviewRoundRoute'),
  })),
  {
    path: profilePathPrefixes.scheduledReviewHistory.slice(1),
    lazy: () =>
      import('../../features/learning/ui/ScheduledReviewHistoryRoute'),
  },
]
